export default function addState(provider, state, path, parameters) {
	provider
		.state(state, {
			url: path,
			template: ' ',
			onEnter: function ($stateParams) {
				$(document).trigger(state, $stateParams);
			},
			params: angular.extend({}, parameters)
		});
}
